export default __webpack_public_path__ + "static/media/Group 30.39da4921.svg";